<template>
  <div>
    <BookingTable :fields="fields" :isAdmin="false" />
  </div>
</template>

<script>
import BookingTable from "../../components/bookings/BookingTable";
import PaymentsService from "@/services/payments";
import { mapGetters } from "vuex";

export default {
  components: { BookingTable },
  data() {
    return {
      fields: [
        {
          key: "name",
          tdClass: "name",
          label: this.$t("utils.table.name"),
          sortable: true
        },
        {
          key: "booked_at",
          label: this.$t("utils.table.booked-at"),
          sortable: true
        },
        {
          key: "seat_type",
          label: this.$t("utils.table.seat-type"),
          sortable: true
        },
        {
          key: "when",
          label: this.$t("utils.table.when"),
          sortable: true
        },
        {
          key: "status",
          label: this.$t("utils.table.status"),
          sortable: true
        },
        {
          key: "confirmation_code",
          label: this.$t("utils.table.confirmation-code")
        },
        {
          key: "reject",
          label: ""
        }
      ]
    };
  },
  computed: {
    ...mapGetters("space", ["status"])
  },
  mounted() {
    if (!this.status || this.status === "draft" || this.status === "rejected") {
      this.$router.push({ name: "WelcomePage" });
    } else {
      this.$store.dispatch("sidebar/setAction", "published");
      this.getPayment();
    }
  },
  methods: {
    async getPayment() {
      const { spaces } = this.$store.getters["currentUser/user"];
      const { space } = await PaymentsService.getPaymentsById(spaces[0]);
      if (space) {
        this.$store.dispatch("utils/setSectionName", space.name);
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/bookings/BookingsPage.vue